export default "__VITE_PUBLIC_ASSET__676629fc__"